import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";

function MainLayout() {
  return (
    <div className="bg-base-100 min-h-screen shadow-xl">
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow mx-auto py-6 px-4 w-full max-w-[1420px]">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default MainLayout;
